/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable i18next/no-literal-string */
/* eslint-disable no-new */
import React, { useContext, useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import Chart from 'chart.js/auto';
import { Grid, Skeleton, Table, TableBody, TableHead, TableRow } from '@mui/material';
import { createContainer, useContainer } from 'unstated-next';
import styled from 'styled-components';
import UserImage from './UserImage';
import { ContentItem } from './types';
import { ProfileContext } from '../../../ProfileContext';
import AdminAuthContainer from '../../../AdminAuthContainer';

export const ProfileDetailProfile = () => {
/*
    const { authMode } = useContainer(AdminAuthContainer);
    let profileData = {
        userImage: 'https://media.istockphoto.com/id/1338134336/photo/headshot-portrait-african-30s-man-smile-look-at-camera.jpg?s=612x612&w=0&k=20&c=kUVdvBnwnZRxausswIKRZuC25bZgTXwrmGSPikdcOro=',
        userTitle: 'Mr. Samuels',
        gradeLevel: '5th / 6th Grade',
        school: 'Canyon Middle School',
        classTypes: 'Science, Math, English'
    };
    if (authMode === 'student') {
        profileData = {
            userImage: 'https://media.istockphoto.com/id/854169794/photo/elementary-student-going-back-to-school.jpg?s=612x612&w=0&k=20&c=APEN-3y-QUx-3oaNJe0zNCjgpveudmDS1IxIhU63vT0=',
            userTitle: 'Sammy Student',
            gradeLevel: '6th Grade',
            school: 'Canyon Middle School',
            classTypes: ''
        };
    }
    const engagementChartId = `engagementChart_${Math.floor(Math.random() * 1000000)}`;
    const attendanceChartId = `engagementChart_${Math.floor(Math.random() * 1000000)}`;
    const classes = [
        {
            className: 'Biology',
            time: '10:00 am',
            url: 'https://class.com'
        },
        {
            className: 'Creative Writing',
            time: '11:00 am',
            url: 'https://class.com'
        },
        {
            className: 'World History',
            time: '1:00 pm',
            url: 'https://class.com'
        },
        {
            className: 'Algebra',
            time: '2:00 pm',
            url: 'https://class.com'
        }
    ];

    // You can fetch the teacher's information from an API or state here
    const teacher = {
        name: 'Boba Pepper',
        subject: 'Meowthaematics',
        email: 'Boba.Pepper@example.com',
        bio: 'Experienced Meowthamatics professor pawssionate about helping students succeed.'
    };
*/
    const { profileData } = useContext(ProfileContext);
    if (!profileData || profileData.loading) {
        return <></>;
    }
    return (
        <div className="teacher-profile">
            <h1>Your Profile</h1>
            <div className="profile-details">
                <h2>{profileData.user_name}</h2>
                <p>Subject: {profileData.subject}</p>
                <p>Email: {profileData.email}</p>
                <p>Bio: {profileData.bio}</p>
            </div>
            <UserImage student={{ user_name: profileData.user_name, user_image: profileData.user_image }}/>
        </div>
    );
};

/*
export const ProfileDetailProfile23 = () => {
    useEffect(() => {
    // Sample data for the chart (you can replace this with your actual data)
        setTimeout(() => {
            const data = {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                datasets: [
                    {
                        label: 'Engagement Score',
                        backgroundColor: 'rgba(75, 192, 192, 0.2)',
                        borderColor: 'rgba(75, 192, 192, 1)',
                        borderWidth: 1,
                        data: [60, 70, 65, 64, 61, 76, 80, 78, 85, 86, 86, 88]
                    }
                ]
            };
            // Create a chart using Chart.js
            if (document && document != null) {
                const canvas = document.getElementById(engagementChartId) as HTMLCanvasElement;
                const ctx = canvas.getContext('2d');
                new Chart(ctx!, {
                    type: 'line',
                    data,
                    options: {
                        scales: {
                            y: {
                                beginAtZero: true
                            }
                        }
                    }
                });
            }
        }, 1000);
    }, [engagementChartId]);

    useEffect(() => {
        // Sample data for the chart (you can replace this with your actual data)
        setTimeout(() => {
            if (authMode !== 'student') {
                return;
            }
            const data = {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                datasets: [
                    {
                        label: 'Attendance Percentage',
                        backgroundColor: 'rgba(75, 192, 192, 0.2)',
                        borderColor: 'rgba(75, 192, 192, 1)',
                        borderWidth: 1,
                        data: [95, 90, 100, 100, 100, 50, 95, 100, 100, 100, 100, 95]
                    }
                ]
            };
            // Create a chart using Chart.js
            if (document && document != null) {
                const canvas = document.getElementById(attendanceChartId) as HTMLCanvasElement;
                const ctx = canvas.getContext('2d');
                new Chart(ctx!, {
                    type: 'line',
                    data,
                    options: {
                        scales: {
                            y: {
                                beginAtZero: true
                            }
                        }
                    }
                });
            }
        }, 1000);
    }, [attendanceChartId, authMode]);

    return (
        <div className="analytics-page" style={{ position: 'relative' }}>
            <img style={{ position: 'absolute', top: '10px', left: '10px', height: '150px' }} src={profileData.userImage} />
            <div style={{ position: 'absolute', top: '10px', left: '275px' }}>
                {profileData.userTitle}<br/>
                {profileData.gradeLevel}<br/>
                {authMode === 'instructor' && profileData.classTypes}

        <div className="analytics-page">
            <h1>Profile</h1>
            <div className="chart-container">
                <canvas id="analyticsChart" width="400" height="200"></canvas>

            </div>
            <div style={{ position: 'absolute', top: '10px', left: '500px', height: '250px' }}>
                <div style={{ fontSize: '24px' }}>{'15'}</div>
                <div style={{ fontSize: '14px' }}>{'Classes'}</div>
                {authMode !== 'student' && <>
                    <div style={{ fontSize: '24px' }}>{'46'}</div>
                    <div style={{ fontSize: '14px' }}>{'Students'}</div>
                </>}
            </div>
            <div style={{ position: 'absolute', top: '0px', left: '650px', height: '250px' }}>
                <img src={'https://static.vecteezy.com/system/resources/thumbnails/003/100/380/small/modern-university-badges-collection-free-vector.jpg'} width={'200px'} />
            </div>
            <div style={{ position: 'absolute', top: '190px', left: '10px', height: '350px' }}>
                <h2>Upcoming Classes</h2>
                {classes.map((classItem) => (
                    <div>
                        <a href={classItem.url}>{classItem.className}</a> - {classItem.time}
                    </div>
                ))}
            </div>
            <div style={{ position: 'absolute', top: '350px', left: '10px', height: '350px' }}>
                <h2>Engagement over time</h2>
                <div className="chart-container" style={{ position: 'absolute', top: '40px', left: '10px', height: '450px' }}>
                    <canvas id={engagementChartId} width="800" height="300"></canvas>
                </div>
            </div>
            {(authMode === 'student') && <div style={{ position: 'absolute', top: '700px', left: '10px', height: '350px' }}>
                <h2>Attendance over time</h2>
                <div className="chart-container" style={{ position: 'absolute', top: '40px', left: '10px', height: '450px' }}>
                    <canvas id={attendanceChartId} width="800" height="300"></canvas>
                </div>
            </div>}
        </div>
    );
};
*/
